export const CALL_NOTIFY = "CALL_NOTIFY";
export const SHOWSCREENBLOCKMSG = "SHOWSCREENBLOCKMSG";
export const SHOWCOACHMARKS = "SHOWCOACHMARKS";
export const LOGIN_USER = "LOGIN_USER";

export const LOGIN_CATEGORIES = "LOGIN_CATEGORIES";

export const ACTIVE_TAB = "ACTIVE_TAB";
